export default __webpack_public_path__ + "static/media/filpoll02.93a04f52.png";